var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 0V2.625H0V4.375H2.625V7H4.375V4.375H7V2.625H4.375V0H2.625ZM8.75 2.625V4.375H16.625V6.125H11.375C10.4125 6.125 9.625 6.9125 9.625 7.875V13.125C9.625 14.0875 10.4125 14.875 11.375 14.875H16.625V16.625H4.375V8.75H2.625V16.625C2.625 17.0891 2.80937 17.5342 3.13756 17.8624C3.46575 18.1906 3.91087 18.375 4.375 18.375H16.625C17.5875 18.375 18.375 17.5875 18.375 16.625V14.63C18.6395 14.4773 18.8594 14.258 19.0129 13.994C19.1664 13.73 19.2482 13.4304 19.25 13.125V7.875C19.2482 7.5696 19.1664 7.27 19.0129 7.00598C18.8594 6.74195 18.6395 6.5227 18.375 6.37V4.375C18.375 3.4125 17.5875 2.625 16.625 2.625H8.75ZM11.375 7.875H17.5V13.125H11.375V7.875ZM14 9.1875C13.6519 9.1875 13.3181 9.32578 13.0719 9.57192C12.8258 9.81806 12.6875 10.1519 12.6875 10.5C12.6875 10.8481 12.8258 11.1819 13.0719 11.4281C13.3181 11.6742 13.6519 11.8125 14 11.8125C14.3481 11.8125 14.6819 11.6742 14.9281 11.4281C15.1742 11.1819 15.3125 10.8481 15.3125 10.5C15.3125 10.1519 15.1742 9.81806 14.9281 9.57192C14.6819 9.32578 14.3481 9.1875 14 9.1875Z",
    fill: "#9097A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.91f6dc6630e44ada256d6b2ead5c6ca3.svg";
export { ForwardRef as ReactComponent };